export default "__VITE_ASSET__Dq2D60Lk__"